import { render } from "./LeftBar.vue?vue&type=template&id=62ff20f1"
import script from "./LeftBar.vue?vue&type=script&lang=js"
export * from "./LeftBar.vue?vue&type=script&lang=js"

import "./LeftBar.vue?vue&type=style&index=0&id=62ff20f1&lang=less"
script.render = render

export default script